import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';

import { PipesModule } from './pipes/pipes.module';
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";

import { TextAvatarModule } from './text-avatar';

import { IonicGestureConfig } from './IonicGestureConfig';

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";

import { File } from '@ionic-native/file/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';

import { AppComponent } from "./app.component";
import { ActivitiesFiltersComponent } from "./activities-filters/activities-filters.component";
import { DateInputPage } from './date-input/date-input.page';
import { MenuHomeComponent } from "./menu-home/menu-home.component";
import { ContactsFiltersComponent } from "./contacts-filters/contacts-filters.component";
import { ActivityPopoverComponent } from './components/activity-popover/activity-popover.component';
import { DeleteActivityPopoverComponent } from './components/delete-activity-popover/delete-activity-popover.component';
import { SharePopoverComponent } from './components/share-popover/share-popover.component';

import { AppRoutingModule } from "./app-routing.module";

// import { HTTP } from '@ionic-native/http/ngx';

import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { TokenInterceptor } from "./interceptors/token.interceptor";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { DeviceService } from "./services/device.service";
import { AuthenticationService } from "./services/authentication.service";
import { IonicStorageModule } from "@ionic/storage";
import { AuthGuard } from "./services/auth-guard.service";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ModalPage } from './benefits/show/modal.page/modal.page';


@NgModule({
    declarations: [
        AppComponent,
        ModalPage,
    ],
    entryComponents: [
        ModalPage,
    ],
    imports: [
        PipesModule,
        BrowserModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        IonicStorageModule.forRoot(),
        IonicModule.forRoot(),
        AppRoutingModule,
        BrowserAnimationsModule,
        TextAvatarModule,
    ],
    providers: [
        StatusBar,
        DeviceService,
        AuthGuard,
        AuthenticationService,
        SplashScreen,
        SocialSharing,
        File,
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: IonicGestureConfig
        },
        {
            provide: RouteReuseStrategy,
            useClass: IonicRouteStrategy
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
    ],
    bootstrap: [AppComponent],

})
export class AppModule { }
